import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { ListSharedModule } from '../../shared/list-shared.module';
import { ListDetailPageRoutingModule } from './list-detail-routing.module';
import { ListDetailPage } from './list-detail.page';
import { PricingModule } from '@app/pricing/pricing.module';
import { SharedProductModule } from '@app/shared-product/shared-product.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    ListDetailPageRoutingModule,
    ListSharedModule,
    ScrollingModule,
    TranslateModule,
    SharedProductModule,
    PricingModule,
  ],
  declarations: [ListDetailPage],
})
export class ListDetailPageModule {}
